// next-app/src/components/survey/waiver.tsx
'use client';

import { FormCheckbox } from '@/components/form/form-checkbox';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ScrollArea } from '@/components/ui/scroll-area';

interface WaiverProps {
  waiverText?: string;
  disabled?: boolean;
}

const DEFAULT_WAIVER_TEXT = `By participating in this Lincoln Embrace for Good event, I acknowledge and agree to the following:

1. I am at least 18 years of age and possess a valid driver's license.

2. I understand that I am participating in a test drive event and will operate the vehicle in a safe and responsible manner, obeying all traffic laws and regulations.

3. I understand that Lincoln Motor Company and the hosting dealer are not responsible for any personal injury or property damage that may occur during my participation in this event.

4. I grant Lincoln Motor Company and its affiliates permission to use any photographs or video recordings taken during this event for marketing and promotional purposes.

5. I understand that my personal information will be collected and used in accordance with Lincoln's Privacy Policy.

6. I certify that I am not under the influence of alcohol or any substances that may impair my ability to safely operate a motor vehicle.

By checking the box below, I confirm that I have read, understand, and agree to the terms and conditions stated above.`;

/**
 * Legal waiver component for pre-drive surveys.
 * Displays waiver text and requires acceptance checkbox.
 */
export function Waiver({ waiverText = DEFAULT_WAIVER_TEXT, disabled }: WaiverProps) {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Terms and Conditions</h2>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Waiver and Release of Liability</CardTitle>
        </CardHeader>
        <CardContent>
          <ScrollArea className="h-48 rounded border bg-muted/50 p-4">
            <div className="whitespace-pre-wrap text-sm text-muted-foreground">{waiverText}</div>
          </ScrollArea>
        </CardContent>
      </Card>

      <FormCheckbox
        name="waiver_accepted"
        label="Agreement"
        checkboxText="I have read and agree to the terms and conditions above"
        disabled={disabled}
      />
    </div>
  );
}
